import {ChatService as TChatService} from '@fnd/timeline'
import EventBus from 'web-common/services/EventBus'

export const ChatService = TChatService.shared(EventBus)
